module.exports = __webpack_public_path__ + "img/ly.e707148f.svg";